module.exports = __webpack_public_path__ + "img/D0014.338a223a.svg";